import { createAction, props } from '@ngrx/store'
import { HomePageSection, User } from './user.model'


export enum AuthActionTypes {
  LOGINBYIP = '[Auth] Login By IP Address',
  LOGIN = '[Auth] Login',
  LOGIN_COMPLETE = '[Auth] Login Complete',
  LOGIN_DEMO_USER = '[Auth] Login Demo User',
  LOGIN_ERROR = '[Auth] Login Error',
  LOGIN_RETURN = '[Auth] Store Return To URL',
  LOGOUT = '[Auth] Logout',
  LOGOUTBYIP = '[Auth] IP Logout',
  USER = '[User] Get Details',
  UPDATEUSER = '[User] Update User',
  IMPERSONATEUSER = '[User] Impersonate',
  UPDATEUSERHASSEEN = '[User] Update User hasSeen',
  UPDATEUSERHOMEPAGESECTIONS = '[User] Update User Homepage Sections',
  UPDATEUSERNEXTGENCSO = '[User] Update User NextGenCSO',
}

export const loginByIPAddress = createAction(
  AuthActionTypes.LOGINBYIP,
)

export const loginUser = createAction(
  AuthActionTypes.LOGIN,
  props<{ email: string, password: string }>()
)

export const loginComplete = createAction(
  AuthActionTypes.LOGIN_COMPLETE,
  props<{ user: User }>()
)

export const loginDemoUser = createAction(
  AuthActionTypes.LOGIN_DEMO_USER,
  props<{ user: User }>()
)


export const loginError = createAction(
  AuthActionTypes.LOGIN_ERROR,
  props<{ error: string }>()
)

export const logout = createAction(
  AuthActionTypes.LOGOUT,
  props<{ error: string }>()
)

export const logoutByIP = createAction(
  AuthActionTypes.LOGOUTBYIP,
  props<{ error: string }>()
)

export const setReturnToURL = createAction(
  AuthActionTypes.LOGIN_RETURN,
  props<{ urlAfterLogin: string }>()
)

export const getUserDetails = createAction(
  AuthActionTypes.USER,
)

export const updateUser = createAction(
  AuthActionTypes.UPDATEUSER,
  props<{ user: User }>()
)

export const updateUserHasSeen = createAction(
  AuthActionTypes.UPDATEUSERHASSEEN,
  props<{ label: string }>()
)

export const updateUserHomePageSections = createAction(
  AuthActionTypes.UPDATEUSERHOMEPAGESECTIONS,
  props<{ sections: HomePageSection[] }>()
)

export const updateUserNextGenCSO = createAction(
  AuthActionTypes.UPDATEUSERNEXTGENCSO,
  props<{ nextGenCSO: string }>()
)

export const impersonateUser = createAction(
  AuthActionTypes.IMPERSONATEUSER,
)